import { render, staticRenderFns } from "./wxAccountManage.vue?vue&type=template&id=06f50783&scoped=true"
import script from "./wxAccountManage.vue?vue&type=script&lang=js"
export * from "./wxAccountManage.vue?vue&type=script&lang=js"
import style1 from "./wxAccountManage.vue?vue&type=style&index=1&id=06f50783&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f50783",
  null
  
)

export default component.exports